/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdminSingleChapterData, AdminSingleChapterMeta } from '@INTERFACES/admin-api/chapters';

export interface ChapterIntroductionTextModalDispatchParams {
    chapterData: AdminSingleChapterData;
    chapterMeta: AdminSingleChapterMeta;
    canEditDocument: boolean;
}

export interface ChapterIntroductionTextModalState {
    isOpen: boolean;

    data: {
        chapterData: AdminSingleChapterData;
        chapterMeta: AdminSingleChapterMeta;
        canEditDocument: boolean;
    } | null;
}

const initialState: ChapterIntroductionTextModalState = {
    isOpen: false,
    data: null,
};

export const chapterIntroductionTextModalSlice = createSlice({
    name: 'chapter-introduction-text-modal',
    initialState,
    reducers: {
        open(state: ChapterIntroductionTextModalState, action: PayloadAction<ChapterIntroductionTextModalDispatchParams>) {
            state.isOpen = true;
            state.data = action.payload;
        },
        close(state: ChapterIntroductionTextModalState) {
            state.isOpen = false;
            state.data = null;
        },
    },
});

